<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      right
      top
      :color="snackbarColor"
      >{{ text }}</v-snackbar
    >
    <v-dialog v-model="dialog" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="black">mdi-square-edit-outline</v-icon>
      </template>
      <v-card class="pa-3 pop_bg">
        <v-card-title>
          <span class="text-h6 primary--text"></span>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="subtitle-1 mb-0 mt-6">
          <v-layout>
            <v-flex class="black--text"> </v-flex>
            <v-flex class="black--text text-body-1">
              Generated through payment gateway.
            </v-flex>
          </v-layout>
          <v-layout justify-end class="mt-8">
            <v-btn
              color="secondary"
              class="me-5 text-capitalize black--text"
              @click="checkPaymentStatus()"
              :loading="btnPaymentStatusLoading"
            >
              <v-icon>mdi-refresh</v-icon> Payment Status
            </v-btn>
          </v-layout>
        </v-card-text>
        <v-card-actions justify="center">
          <v-row justify="center"> </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    appointment: {
      required: true
    }
  },
  data() {
    return {
      valid: true,
      btnPaymentStatusLoading: false,
      btnRegenerateLoading: false,
      isPermanentlyDelete: true,
      dialog: false,
      button_loading: false,
      show_alert: false,
      error: null,
      alertData: {
        value: true,
        msg: "Member deleted !",
        msg_ar: "تم حذف العضو!",
        type: "success"
      },
      snackbar: false,
      snackbarColor: "",
      text: ""
    };
  },
  methods: {
    checkPaymentStatus() {
      // debugger;
      this.btnPaymentStatusLoading = true;
      this.$apollo
        .query({
          query: require("../api/checkDietitianPaymentStatus.graphql"),
          variables: {
            appointmentId: this.appointment._id
          }
        })
        .then(data => {
          this.btnPaymentStatusLoading = false;
          if (data.data.checkDietitianPaymentStatus) {
            this.$root.$emit("updateAppointment");
            this.button_loading = false;
            this.dialog = false;
            this.text = "Appointment payment received.";
            this.snackbarColor = "success";
            this.snackbar = true;
          } else {
            this.text = "No payment received";
            this.snackbarColor = "error";
            this.snackbar = true;
            this.dialog = false;
            this.button_loading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.btnPaymentStatusLoading = false;
          this.text = "Something went wrong";
          this.snackbarColor = "error";
          this.snackbar = true;
          this.dialog = false;
          this.button_loading = false;
        });
    },

    close() {
      this.error = null;
      this.dialog = false;
    }
  }
};
</script>
